<template>
  <div class="wrapper">
    <parallax
      class="section page-header header-filter"
      :style="{
        backgroundImage: 'url(' + header_pictures.faq_header_picture.url + ')',
      }"
    ></parallax>
    <div class="main main-raised">
      <div class="section profile-content">
        <div class="faqs-section">
          <h2 class="text-left">Frequently Asked Questions</h2>
          <div class="short-desc">
            <br />
            Below is a list of the most frequently asked questions you have
            asked with answers, links, and contacts to direct you to more
            information.
            <br />
            <br />
          </div>
          <Loader v-if="loading" />
          <div
            class="faq-category"
            v-for="faq_category in faq_categories"
            :key="faq_category.id"
            v-else
          >
            <h3>
              <strong>{{ faq_category.name }}</strong>
            </h3>
            <div v-for="faq in faq_category.faqs" :key="faq.id">
              <!-- <p>{{faq.faq_question}}</p>
                  <p>{{faq.faq_answer}}</p> -->
              <Faqcordion :faq="faq"></Faqcordion>
            </div>
          </div>

          <br>

          <div class="faq-cta-container" >

            <div class="dabutton-left faq-cta">
              <h4><strong> Reach out for more questions or comments.</strong></h4>
              
              <md-button
                href="/contact"
                class="md-primary md-lg"
                >Contact Us</md-button
              >
              <!-- <br> -->
            </div>

            <div class="dabutton-right faq-cta">
              <h4><strong> Find out more about our company.</strong></h4>
              <md-button
                href="/about"
                class="md-primary md-lg"
                >About Us</md-button
              >
            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loader from "@/components/Loader.vue";
import Faqcordion from "@/components/Faqcordion.vue";

export default {
  components: {
    Loader,
    Faqcordion,
  },
  bodyClass: "profile-page",
  data() {
    return {
      loading: true,
      faq_categories: [],
    };
  },
  props: {
    header_pictures: Object
  },
  mounted() {
    axios.get("https://strapi-asiongs.herokuapp.com/faq-categories", {}).then(
      (response) => {
        this.faq_categories = response.data;
        this.loading = false;
      },
      (error) => {
        // console.log(error);
      }
    );
  },
  metaInfo() {
    return{
      title: 'Frequently Asked Questions',
      meta: [
        { name: 'description', content:  "Asiong's Industrial Products is an importer and distributor for general safety equipment. We provide an extensive range of industrial products and Personal Protective Equipment (PPE)."},
        { property: 'og:title', content: "Asiong's Industrial Products"},
        { property: 'og:description', content:  "Asiong's Industrial Products is an importer and distributor for general safety equipment. We provide an extensive range of industrial products and Personal Protective Equipment (PPE)."},
        { property: 'og:site_name', content: 'Asiongs Industrial Products'},
        { property: 'og:type', content: 'website'},    
        { property: 'og:image', content: this.header_pictures.faq_header_picture.url}
      ]
    }
  }
};
</script>

<style lang="scss" scoped>

.section {
  padding: auto;
  overflow: hidden;
}

.profile-tabs::v-deep {
  .md-card-tabs .md-list {
    justify-content: center;
  }

  [class*="tab-pane-"] {
    margin-top: 3.213rem;
    padding-bottom: 50px;

    img {
      margin-bottom: 2.142rem;
    }
  }
}

.faqs-section {
  padding: 48px;
  margin: auto;
  max-width: 800px;
  overflow: hidden;
}

.faq-category {
  margin-bottom: 24px;
}

h3 {
  color: #182e5a;
}

h2 {
  font-weight: bold;
}

hr {
  border-top: 1px solid #182e5a;
}

p {
  font-size: 24px;
}

.contact-button {
  background: linear-gradient(to bottom, #ffffff 5%, #f6f6f6 100%);
  background-color: #ffffff;
  border-radius: 6px;
  border: 1px solid #dcdcdc;
  display: inline-block;
  color: white;
  font-family: Arial;
  font-size: 14px;
  text-decoration: none;
  font-weight: bold;
  padding: 8px 40px;
  text-decoration: none;
}

.contact-button span {
  cursor: pointer;
  display: inline-block;
  position: relative;
  transition: 0.5s;
}

.contact-button span:after {
  content: "\00bb";
  position: absolute;
  opacity: 0;
  top: 0;
  right: -20px;
  transition: 0.5s;
}

.contact-button:hover span {
  padding-right: 25px;
}

.contact-button:hover span:after {
  opacity: 1;
  right: 0;
}

.faq-cta-container{
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px , 1fr));
  grid-auto-rows: 1fr;
  grid-gap: 16px;

  .faq-cta{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 16px;
    border: 2px solid #182e5a;
  }

  
}





</style>
